import { MainLayout } from 'layouts'
import { LkmAppeals } from 'feature/lkmAppeals/components/lkmAppeals'

export function LkmOrdersPage() {
  return (
    <MainLayout>
      <div className='container'>
        <LkmAppeals />
      </div>
    </MainLayout>
  )
}
